module.exports = __webpack_public_path__ + "img/online_protection_flatline.ef96cddb.svg";